/* eslint-disable no-undef */

import { ref } from 'vue'
import { useGmap } from './useGmap'

let service = null

export async function useGetDistance (data) {
  const distanceData = ref(null)

  // create loader via composable in function scope to avoid lifecycle issues
  const { load } = useGmap()
  const google = await load()

  service = new google.maps.DistanceMatrixService()
  await service.getDistanceMatrix(
    {
      origins: [data.rider, data.shop],
      destinations: [data.shop, data.drop],
      travelMode: 'DRIVING'
    }, (response, status) => {
      distanceData.value = response
      // console.log('response, status', response, status)
    })

  return { distanceData }
}
